import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  MatBottomSheet,
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';
import { Subscription } from 'rxjs';
import { kitchenSearchItem } from 'src/app/core/model/api-response/cooking-story-model';
import {
  foodUnitRatioArray,
  personalFood,
} from 'src/app/core/model/api-response/persoanl-response-model';
import { CookingStoryKitchenDataService } from 'src/app/data/repository/cooking-story/cooking-story-kitchen-data.service';
import { GenerateShared } from 'src/app/presentation/general/shared/generate-shared';
import { RegisterShared } from 'src/app/presentation/general/shared/register-shared';
import { DateHelper } from 'src/app/utils/date-helper';
import { ListFormat } from 'typescript';
import { KitchenRemoveConfirmComponent } from '../../../kitchen-remove-confirm/kitchen-remove-confirm.component';
import { KitchenSearchDateComponent } from './kitchen-search-date/kitchen-search-date.component';
import { KitchenSearchUnitComponent } from './kitchen-search-unit/kitchen-search-unit.component';

@Component({
  selector: 'app-kitchen-search-edit',
  templateUrl: './kitchen-search-edit.component.html',
  styleUrls: ['./kitchen-search-edit.component.scss'],
})
export class KitchenSearchEditComponent implements OnInit, OnDestroy {
  SWIPE_ACTION = { UP: 'swipeup', DOWN: 'swipedown' };
  foodName: string = '';
  amount: number = null;
  selectedRatio;
  date;
  unitList;
  isActive: boolean = false;
  kitchenItemData: kitchenSearchItem;
  activeId: string;
  foodUnitRatioArray: foodUnitRatioArray[];
  unitDescription: string;
  description: string;
  dateText: string;
  id: string;
  type: 'edit' | 'search';
  subscriptions: Subscription[] = [];

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: { food: personalFood | kitchenSearchItem; id: string },
    private bottomSheetRef: MatBottomSheetRef<KitchenSearchEditComponent>,
    private matBottomSheet: MatBottomSheet,
    private registerShared: RegisterShared,
    private dateHelper: DateHelper,
    private cookingStoryKitchenDataService: CookingStoryKitchenDataService
  ) // private cdr: ChangeDetectorRef
  {
    // this.cookingStoryKitchenDataService.dateChanged.subscribe(() => {
    //   this.date = this.cookingStoryKitchenDataService.getUnsavedDate(this.id);
    //   this.dateText = this.getDateInPersian();
    //   this.cdr.detectChanges();
    // });
  }

  async ngOnInit() {
    this.type = this.cookingStoryKitchenDataService.type;

    if (!this.data) {
      this.activeId = this.cookingStoryKitchenDataService.getActiveItem();
    } else {
      if ((this.data.food as personalFood)._id) {
        this.activeId = this.data.id;
      } else {
        this.activeId = (this.data.food as kitchenSearchItem).id;
      }
    }
    this.cookingStoryKitchenDataService.changeActiveItem(this.activeId);
    this.unitList = await this.cookingStoryKitchenDataService.getUnitList();
    if (this.cookingStoryKitchenDataService.getActiveItem()) {
      this.replaceData();
    }
    this.checkActive();
  }
  checkActive() {
    if ((this.amount && this.amount > 0) || this.type == 'edit') {
      this.isActive = true;
      this.cookingStoryKitchenDataService.addUnsavedAmount(
        this.activeId,
        this.amount
      );
      this.cookingStoryKitchenDataService.addUnsaved(
        this.activeId,
        this.unitDescription
      );
      this.cookingStoryKitchenDataService.addUnsavedDescription(
        this.activeId,
        this.description
      );
    } else {
      this.isActive = false;
    }
  }
  swipe(action: string = this.SWIPE_ACTION.DOWN) {
    if (action === this.SWIPE_ACTION.DOWN) {
      this.bottomSheetRef.dismiss();
    }
  }
  goBack() {
    this.bottomSheetRef.dismiss();
  }
  openDate() {
    const bottomSheetRef = this.matBottomSheet.open(
      KitchenSearchDateComponent,
      {
        disableClose: true,
        panelClass: 'custom-bottomsheet-container',
        data: {
          ...this.data,
        },
      }
    );
    const sub = bottomSheetRef.afterDismissed().subscribe((dataFromChild) => {
      console.log({ time: this.date, dataFromChild });

      this.dateText = this.getDateInPersian();
    });
    const overlay = bottomSheetRef.backdropClick().subscribe((data) => {
      this.repoenHere();
    });
    this.subscriptions.push(sub, overlay);
  }
  repoenHere() {
    const bottomSheetRef = this.matBottomSheet.open(
      KitchenSearchEditComponent,
      {
        panelClass: 'custom-bottomsheet-container',
      }
    );
  }
  openChangeUnit() {
    const bottomSheetRef = this.matBottomSheet.open(
      KitchenSearchUnitComponent,
      {
        panelClass: 'custom-bottomsheet-container',
      }
    );
    const sub = bottomSheetRef
      .afterDismissed()
      .subscribe((dataFromChild) => {});
    const overlay = bottomSheetRef.backdropClick().subscribe((data) => {
      this.repoenHere();
    });
    this.subscriptions.push(sub, overlay);
  }
  replaceData() {
    this.kitchenItemData = this.cookingStoryKitchenDataService.getItem(
      this.activeId
    );
    console.log(this.kitchenItemData);

    this.id = this.kitchenItemData.id;
    this.foodName = this.kitchenItemData.name;

    const unsavedDate = this.cookingStoryKitchenDataService.getUnsavedDate(
      this.activeId
    );
    if (unsavedDate) {
      this.date = unsavedDate;
      this.dateText = this.getDateInPersian();
      console.log({ unsavedDate: unsavedDate });
    } else if (this.kitchenItemData.expireDate) {
      this.date = this.kitchenItemData.expireDate;
      this.dateText = this.getDateInPersian();
      console.log({ exp: this.kitchenItemData.expireDate, dd: this.date });
    }
    if (this.kitchenItemData.amount) {
      this.amount = this.kitchenItemData.amount;
    } else {
      const unsaved = this.cookingStoryKitchenDataService.getUnsavedAmount(
        this.activeId
      );

      if (unsaved) {
        this.amount = unsaved;
      }
    }
    if (this.kitchenItemData.description) {
      this.description = this.kitchenItemData.description;
    } else {
      const unsaved = this.cookingStoryKitchenDataService.getUnsavedDescription(
        this.activeId
      );

      if (unsaved) {
        this.description = unsaved;
      }
    }
    if (this.kitchenItemData.unitDescription) {
      this.unitDescription = this.kitchenItemData.unitDescription;
    } else {
      const unsaved = this.cookingStoryKitchenDataService.getUnsavedItem(
        this.activeId
      );

      if (unsaved) {
        this.unitDescription = unsaved;
      }
    }
  }
  getDateInPersian() {
    return this.dateHelper.pickerGetYearAndMonthAndDayPersian(this.date);
  }
  save() {
    if (this.isActive) {
      const data = new kitchenSearchItem(
        this.kitchenItemData.food,
        null,
        parseInt(this.amount as any),
        null,
        this.unitDescription,
        this.description,
        this.date,
        this.foodName,
        this.foodUnitRatioArray,
        true,
        this.id
      );
      this.cookingStoryKitchenDataService.clearUnsaved();
      this.cookingStoryKitchenDataService.updateSave(this.activeId, data);
      this.bottomSheetRef.dismiss();
    }
  }
  delete() {
    // this.cookingStoryKitchenDataService.deleteItemList([this.activeId]);
    // this.cookingStoryKitchenDataService.clearUnsaved();
    this.matBottomSheet.open(KitchenRemoveConfirmComponent, {
      panelClass: 'custom-bottomsheet-container',
      data: {
        id: this.id,
        type: 'kitchen',
        foodname: this.foodName,
      },
    });
    this.bottomSheetRef.dismiss();
  }
  update() {
    if (this.isActive) {
      const data = new kitchenSearchItem(
        this.kitchenItemData.food,
        null,
        this.amount,
        null,
        this.unitDescription,
        this.description,
        this.date,
        this.foodName,
        this.foodUnitRatioArray,
        true,
        this.id
      );
      this.cookingStoryKitchenDataService.clearUnsaved();

      this.cookingStoryKitchenDataService.updateAndSave(this.activeId, data);
      this.bottomSheetRef.dismiss();
    }
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
}
